






















import { Component, Prop, Mixins } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import StatementModule from '@/store/modules/Statement';
import Table from '@/components/Table/Index.vue';
import StatementBody from '@/components/Table/StatementBody.vue';
import Pagination from '@/components/Pagination.vue';
import DepositWithdrawData from '@/data/DepositWithdrawData';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';
import PaginationMixin from '@/mixins/Pagination.vue';

@Component({
  components: {
    Table,
    Pagination,
    StatementBody,
  },
})
export default class Statement extends Mixins(ErrorHandleMixin, PaginationMixin) {
  @Prop() readonly statementCriteria!: any;

  @Prop() readonly period!: any;

  @Prop() readonly currencyRate!: any;

  @Prop() readonly toggleMode!: boolean;

  StatementInstance = getModule(StatementModule, this.$store);

  PaginationDetail = {
    current: 1,
    amount: 0,
    size: 100,
  };

  dataList: any = [];

  TableHead = DepositWithdrawData.TableHeadDetail;

  sum = 0;

  created() {
    this.fetchStatement();
  }

  async fetchStatement() {
    this.GeneralInstance.toggleLoading(true);
    const criteria = {
      ...this.statementCriteria,
      ...this.period,
      ...this.PaginationDetail,
    };
    const { data, status } = await this.StatementInstance.FetchStatementDetail(criteria);
    this.checkError(status);
    this.dataList = [...data.report];
    this.sum = data.footer;
    this.GeneralInstance.toggleLoading(false);
  }
}
